// @flow
import {List, Set} from 'immutable';
import moment from 'moment';
import {
  mandarkEndpoint,
  type QueryBuilder
} from '@albert-io/json-api-framework/request/builder/legacy';
import {selectorComponentNames} from 'client/generic/ScopeSelector/ScopeSelector.react';
import appStore from 'client/AppStore';

const DATE_TIME_FORMAT = 'YYYY-MM-DD';

const selectorComponents = new Set([
  selectorComponentNames.attemptSelector,
  selectorComponentNames.dateRangeSelector,
  selectorComponentNames.subjectSelector
]);

// *** Public functions ***
const publicInterface = {
  areSubjectsReady(): boolean {
    return this.getSubjectsQuery().isResourcePopulated();
  },

  getSubjectsQuery(): QueryBuilder {
    return mandarkEndpoint(['subjects_v2'])
      .meta({
        context: {
          student: {
            id: this.getStudentId()
          }
        }
      })
      .customQuery({
        with_meta: 'subject_v2'
      })
      .sort('name')
      .pageSize('infinite');
  },

  getSubjects(): List<*> {
    return this.getSubjectsQuery().getResource();
  },

  getStudentId(): string {
    return appStore.routerProps.params.studentId;
  },

  getDefaultSubjectId(): ?string {
    return appStore.routerProps.params.subjectId;
  },

  getSelectorComponents(): Set<string> {
    return selectorComponents;
  },

  // XXX Ideally we refactor the generic DateRange component to accept just plain
  // moment objects rather than a specific string format
  getDefaultEndDate(): string {
    return moment().format(DATE_TIME_FORMAT);
  },

  getDefaultStartDate(): string {
    return moment()
      .subtract(30, 'days')
      .format(DATE_TIME_FORMAT);
  }
};

export default publicInterface;
